export const SET_FABRICANTES = 'fabricante/SET_FABRICANTES';

export const setFabricantes = fabricantes => {
  return {
    type: SET_FABRICANTES,
    payload: fabricantes
  };
};
